import { logWarn } from '../services/loggerService';

/**
 * Classify and log a failure from a share handler (navigator.share, clipboard
 * write, or the /share ref mint).
 *
 * navigator.share() rejects with a DOMException named `AbortError` when the user
 * simply dismisses the OS share sheet — an expected, benign outcome, so we stay
 * silent on it. Everything else is a real failure that a bare `catch {}` used to
 * eat: most notably `NotAllowedError`, which is how Safari/WebKit reports a share
 * invoked without transient user activation (the bug behind this whole change),
 * plus clipboard-write rejections. Those now surface through `logWarn` so they
 * land in the cloud log trace instead of vanishing.
 *
 * Network failures from the /share mint are already logged + modal'd by
 * apiService before they reach here; the extra warn is additive and tags the
 * failure with the share surface (`context`), which the generic API log lacks.
 *
 * @param context short label for the share surface, e.g. 'listing-share'.
 */
export function logShareFailure(err: unknown, context: string): void {
  // User dismissed the share sheet — not a failure.
  if (err instanceof DOMException && err.name === 'AbortError') return;

  const name = err instanceof Error ? err.name : 'UnknownError';
  const message = err instanceof Error ? err.message : String(err);
  logWarn(`Share failed (${context})`, undefined, { name, message });
}
